import { findSportByLeague } from "./utils"
/* 
This file stores mapping between actual_names coming from API to Human Understandable Titles.
*/

// -------------------------------------------- Conventions -----------------------------------------------

export const getStatsColumnMapping = (league, remoteConfig = null) => {
  var rcLeagueObject;
  if (process.env.REACT_APP_ENV === "production") {
    rcLeagueObject = JSON.parse(remoteConfig.config.leagueConf._value)[
      "leagues"
    ].find(
      (leagueObj) => leagueObj.leagueName.toLowerCase() === league.toLowerCase()
    );
  } else {
    rcLeagueObject = JSON.parse(remoteConfig.config.leagueConfTesting._value)[
      "leagues"
    ].find(
      (leagueObj) => leagueObj.leagueName.toLowerCase() === league.toLowerCase()
    );
  }
  const suffix = rcLeagueObject.stats.recentNumberOfGames;
  const season = rcLeagueObject.season;
  const sport = findSportByLeague(league, remoteConfig, "columnjsoninformation -- getStatsColumnMapping");
  // console.log("getStatsColumnMapping sport: ", sport)
  var statsList = [
    {
      actual_name: "Dream11ProjectedFantasyPoints",
      display_name: "PFP",
      full_name: "Projected Fantasy Points",
      description: "The Dream11 Fantasy Points Projection for the player",
      default_value: false,
      show: false,
      reducer_name: "ps_proj_fp",
      lineup_param: true,
      desc_sort_order: true
    },
    {
      actual_name: "MatchesPlayed",
      display_name: "#GP",
      full_name: "Games Played",
      description: "Total Games Played in Current Season",
      default_value: false,
      show: true,
      reducer_name: "ps_m_played",
      lineup_param: false,
      desc_sort_order: true
    },
    {
      actual_name: "InDreamteam",
      display_name: "#DT",
      full_name: "Dream Team Count",
      description: "Number of times the player was in Dream Team",
      default_value: false,
      show: true,
      reducer_name: "ps_dt_count",
      lineup_param: false,
      desc_sort_order: true
    }
  ];

  if (sport === "CRICKET") {
    statsList = statsList.concat(
      {
        actual_name: "DTA",
        display_name: "DTA%",
        full_name: "Dream Team Appearance",
        description: "Number of times the Player was in Dream Team",
        default_value: false,
        show: true,
        reducer_name: "ps_dta",
        lineup_param: false,
        desc_sort_order: true
      }
    )
  }

  if (sport === "BASKETBALL") {
    statsList = statsList.concat(
      [
        {
          actual_name: "TimesCap",
          display_name: "#S",
          full_name: "Dream Team Star Count",
          description: "Number of times the Player was Star in Dream Team",
          default_value: false,
          show: true,
          reducer_name: "ps_cap_count",
          lineup_param: false,
          desc_sort_order: true
        },
        {
          actual_name: "TimesVCap",
          display_name: "#P",
          full_name: "Dream Team Pro Count",
          description: "Number of times the Player was Pro in Dream Team",
          default_value: false,
          show: true,
          reducer_name: "ps_vcap_count",
          lineup_param: false,
          desc_sort_order: true
        }
      ]
    )
  }
  else {
    statsList = statsList.concat(
      [
        {
          actual_name: "TimesCap",
          display_name: "#C",
          full_name: "Dream Team Captain Count",
          description: "Number of times the Player was Captain in Dream Team",
          default_value: false,
          show: true,
          reducer_name: "ps_cap_count",
          lineup_param: false,
          desc_sort_order: true
        },
        {
          actual_name: "TimesVCap",
          display_name: "#VC",
          full_name: "Dream Team Vice Captain Count",
          description: "Number of times the Player was Vice Captain in Dream Team",
          default_value: false,
          show: true,
          reducer_name: "ps_vcap_count",
          lineup_param: false,
          desc_sort_order: true
        }
      ]
    )
  }

  if (sport === "CRICKET") {
    statsList = statsList.concat(
      [
        {
          actual_name: "TotalRank",
          display_name: "#TFPR",
          full_name: "Total Rank",
          description: "Cumulative of all the Dream Team Rank of Player",
          default_value: false,
          show: true,
          reducer_name: "ps_tfpr_count",
          lineup_param: false,
          desc_sort_order: false
        },
        {
          actual_name: "Total4WRank",
          display_name: "#TFPR (L" + suffix + ")",
          full_name: "Total last " + suffix + " Rank",
          description: "Cumulative of all the Dream Team Rank of Player for last " + suffix + " games",
          default_value: false,
          show: true,
          reducer_name: "ps_tfprL4_count",
          lineup_param: false,
          desc_sort_order: false
        },
        {
          actual_name: "AvgRank",
          display_name: "#AFPR",
          full_name: "Average Rank",
          description: "Average Rank of Player in Dream Ream",
          default_value: false,
          show: true,
          reducer_name: "ps_afpr_count",
          lineup_param: false,
          desc_sort_order: false
        },
        {
          actual_name: "Avg4WRank",
          display_name: "#AFPR (L" + suffix + ")",
          full_name: "Average last " + suffix + " Rank",
          description: "Average Rank of Player in Dream Team for last " + suffix + " games",
          default_value: false,
          show: true,
          reducer_name: "ps_afprL4_count",
          lineup_param: false,
          desc_sort_order: false
        },
        {
          actual_name: "TotalPercentageFP",
          display_name: "TFP%",
          full_name: "Total Percentage Fantasy Point",
          description: "Total Percentage Fantasy Point",
          default_value: false,
          show: true,
          reducer_name: "ps_tfp",
          lineup_param: false,
          desc_sort_order: true
        },
        {
          actual_name: "TotalPercentage4WFP",
          display_name: "TFP (L" + suffix + ")%",
          full_name: "Total Percentage last " + suffix + " Fantasy Point",
          description: "Total Percentage of Fantasy Point for last " + suffix + " games",
          default_value: false,
          show: true,
          reducer_name: "ps_tfpL4",
          lineup_param: false,
          desc_sort_order: true
        },
        {
          actual_name: "AvgPercentageFP",
          display_name: "AFP%",
          full_name: "Average Percentage Fantasy Point",
          description: "Average Percentage Fantasy Point",
          default_value: false,
          show: true,
          reducer_name: "ps_afp",
          lineup_param: false,
          desc_sort_order: true
        },
        {
          actual_name: "AvgPercentage4WFP",
          display_name: "AFP (L" + suffix + ")%",
          full_name: "Average Percentage last " + suffix + " Fantasy Point",
          description: "Average Percentage of Fantasy Point for last " + suffix + " games",
          default_value: false,
          show: true,
          reducer_name: "ps_afpL4",
          lineup_param: false,
          desc_sort_order: true
        },

      ]
    )
  }

  statsList = statsList.concat(
    [
      {
        actual_name: "OperatorPlayerCredits",
        display_name: "CR",
        full_name: "Credits",
        description: "The cost for having the player in your Dream Team",
        default_value: false,
        show: true,
        reducer_name: "ps_credits",
        lineup_param: false,
        desc_sort_order: true
      },
      {
        actual_name: "CSumTotalFP_A",
        display_name: "TFP (" + season + ")",
        full_name: "Total Fantasy Points",
        default_value: false,
        description: "Cumulative Fantasy Points scored by the player",
        show: true,
        reducer_name: "ps_totalFP",
        lineup_param: true,
        desc_sort_order: true
      },
      {
        actual_name: "CSum4WTotalFP_A",
        display_name: "TFP (L" + suffix + ")",
        full_name: "Total Fantasy Points for last " + suffix + " games",
        default_value: false,
        description:
          "Cumulative Fantasy Points scored by the player in last " +
          suffix +
          " games",
        show: true,
        reducer_name: "ps_totalFPL4",
        lineup_param: true,
        desc_sort_order: true
      },
      {
        actual_name: "OperatorBetsMade",
        display_name: "SB%",
        full_name: "Selected By Percentage",
        default_value: false,
        description: "Percentage of teams that include the Player on Dream11",
        show: true,
        reducer_name: "ps_sellBy",
        lineup_param: false,
        desc_sort_order: true
      },
      {
        actual_name: "AvgTotalFP_A",
        display_name: "AFP (" + season + ")",
        full_name: "Points Per Game for " + season + " Season",
        default_value: false,
        description:
          "Average Fantasy Points of the Player in " + season + " Season",
        show: true,
        reducer_name: "ps_ppgYear",
        lineup_param: true,
        desc_sort_order: true
      },
      {
        actual_name: "Avg4WTotalFP_A",
        display_name: "AFP (L" + suffix + ")",
        full_name: "Points Per Game averaged for last " + suffix + " games",
        default_value: false,
        description:
          "Average Fantasy Points of the Player in last " + suffix + " games",
        show: true,
        reducer_name: "ps_ppgL4",
        lineup_param: true,
        desc_sort_order: true
      },
      // {
      //   actual_name: "GPP_RTG_STARS",
      //   display_name: "GPP RTG",
      //   full_name: "Tournament / GPP Rating",
      //   default_value: false,
      //   description: "Player rating best suited for large tournaments",
      //   show: false,
      //   reducer_name: "ps_gpp",
      //   lineup_param: false,
      // },
      // {
      //   actual_name: "H2H_RTG_STARS",
      //   display_name: "H2H RTG",
      //   full_name: "Head to Head (50/50) Rating",
      //   default_value: false,
      //   description: "Player rating best suited for head to head matchups",
      //   show: false,
      //   reducer_name: "ps_h2h",
      //   lineup_param: false,
      // },
      {
        actual_name: "Dream11ProjectedValue",
        display_name: "PV",
        full_name: "Projected Value",
        default_value: false,
        description: "Projected Fantasy Points ÷ Credits",
        show: true,
        reducer_name: "ps_projVal",
        lineup_param: false,
        desc_sort_order: true
      },
      {
        actual_name: "Dream11ValueSeason",
        display_name: "VAL (" + season + ")",
        full_name: "Average Value (" + season + " Season)",
        default_value: false,
        description: "Average Fantasy Points ÷ Average Credits",
        show: true,
        reducer_name: "ps_valYear",
        lineup_param: false,
        desc_sort_order: true
      },
      {
        actual_name: "Dream11ValueLast4Games",
        display_name: "VAL (L" + suffix + ")",
        full_name: "Average Value (Last " + suffix + " Gms)",
        default_value: false,
        description: "Average Fantasy Points ÷ Average Credits",
        show: true,
        reducer_name: "ps_valL4",
        lineup_param: false,
        desc_sort_order: true
      },
      {
        actual_name: "Dream11ProjectedCeilFantasyPoints",
        display_name: "CLG",
        full_name: "Ceiling",
        default_value: false,
        description: "Upside based on past performances",
        show: true,
        reducer_name: "ps_ceil",
        lineup_param: true,
        desc_sort_order: true
      },
      {
        actual_name: "Dream11ProjectedFloorFantasyPoints",
        display_name: "FLR",
        full_name: "Floor",
        default_value: false,
        description: "Least fantasy points player is likely to score",
        show: true,
        reducer_name: "ps_floor",
        lineup_param: true,
        desc_sort_order: true
      }
    ]
  );

  return statsList;
};

export const getOptimizerDisplayNames = (league, remoteConfig = null) => {
  if (league != null) {
    return getStatsColumnMapping(league, remoteConfig).map(
      (column) => column.display_name
    );
  }
};
